<div class="summary-cards-grid">
  <!-- Active Plans Card -->
  <mat-card class="summary-card primary" [class.has-data]="hasActivePlans">
    <div class="card-content">
      <span class="label">Planos Ativos</span>
      <span class="value">{{ activePlansRatio }}</span>
    </div>
  </mat-card>

  <!-- Monthly Total Card -->
  <mat-card class="summary-card success" [class.has-data]="summary.monthlyTotal > 0">
    <div class="card-content">
      <span class="label">Valor Mensal</span>
      <span class="value">{{ summary.monthlyTotal | currency:'BRL' }}</span>
    </div>
  </mat-card>

  <!-- Next Due Date Card -->
  <mat-card 
    class="summary-card warning" 
    [class.has-data]="hasNextDueDate"
    *ngIf="hasNextDueDate">
    <div class="card-content">
      <span class="label">Próximo Vencimento</span>
      <span class="value">{{ summary.nextDueDate | date:'dd/MM/yyyy' }}</span>
    </div>
  </mat-card>

  <!-- Overdue Installments Card -->
  <mat-card 
    class="summary-card error" 
    [class.has-data]="hasOverdueInstallments"
    *ngIf="hasOverdueInstallments">
    <div class="card-content">
      <span class="label">Parcelas Atrasadas</span>
      <span class="value">{{ summary.overdueCount }}</span>
    </div>
  </mat-card>
</div>
